var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-screen',{attrs:{"title":_vm.texts.ob.message.title,"textOnly":true,"menu":true}},[_c('p',[_vm._v(_vm._s(_vm.texts.ob.message.text))]),_c('video',{staticClass:"message-video",attrs:{"playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.texts.ob.message.video}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }